import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";

export default function GarantiaTabla() {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">Nro.</TableCell>
            <TableCell align="center">Unidad de Negocio</TableCell>
            <TableCell align="center">Tiempo de Garantía</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center">1</TableCell>
            <TableCell align="center">AC</TableCell>
            <TableCell>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                <li>1 Mes</li>
                <li>6 Meses</li>
                <li>1 Año</li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">2</TableCell>
            <TableCell align="center">AJ</TableCell>
            <TableCell>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                <li>1 Mes</li>
                <li>1 Año</li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">3</TableCell>
            <TableCell align="center">AT</TableCell>
            <TableCell>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                <li>1 Mes</li>
                <li>1 Año</li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">4</TableCell>
            <TableCell align="center">ET</TableCell>
            <TableCell>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                <li>3 Años</li>
                <li>5 Años</li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">5</TableCell>
            <TableCell align="center">MA</TableCell>
            <TableCell>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                <li>1 Año</li>
                <li>3 Años</li>
                <li>5 Años</li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">6</TableCell>
            <TableCell align="center">MJ</TableCell>
            <TableCell>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                <li>3 Años</li>
                <li>5 Años</li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">7</TableCell>
            <TableCell align="center">PC</TableCell>
            <TableCell>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                <li>1 Mes</li>
                <li>1 Año</li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">8</TableCell>
            <TableCell align="center">PD</TableCell>
            <TableCell>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                <li>1 Mes</li>
                <li>1 Año</li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">9</TableCell>
            <TableCell align="center">RA</TableCell>
            <TableCell>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                <li>1 mes</li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">10</TableCell>
            <TableCell align="center">RJ</TableCell>
            <TableCell>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                <li>1 mes</li>
              </ul>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
